module.exports = __webpack_public_path__ + "img/group-enterprise.ba45083d.svg";